module.exports = __webpack_public_path__ + "resources/sass/fn/fonts/zoom-icon.woff";


//////////////////
// WEBPACK FOOTER
// ./src/resources/sass/fn/fonts/zoom-icon.woff
// module id = 387
// module chunks = 0